import { Component } from '@angular/core';
import { TextModes } from '../../ui/controls/text-input/text-input.component';
import { StorageService } from '../../../core/storage/storageService';
import { CacheService } from '../../../core/storage/cacheService';
import { BaseCustomControl } from '../../ui/controls/baseCustomControl';
import { SolutionDetails } from '../../../models/solution/solutionDetails';
import { PricingStructure } from '../../../core/constants';
import { ListItem } from '../../../../../../../libs/Shared/components/model/listItem';

@Component({
  selector: 'app-merchant-solution',
  templateUrl: './merchant-solution.component.html',
  standalone: false,
})
export class MerchantSolutionComponent {
  solution: SolutionDetails = new SolutionDetails({});
  pricingStructure = PricingStructure;

  inputTextModes = TextModes;
  equipmentOwnershipOptions: ListItem[] = [];
  achProcessorOptions: ListItem[] = CacheService.achProcessorList;
  gatewayOptions: ListItem[] = CacheService.gatewayList;
  pricingStructureOptions: ListItem[] = [
    new ListItem({ id: 'flatrate', name: 'Flat Rate' }),
    new ListItem({ id: 'tiered', name: 'Tiered' }),
    new ListItem({ id: 'interchangeplus', name: 'Interchange+' }),
  ];
  equipmentOptions: ListItem[] = [
    new ListItem({ id: 'none', name: 'No equipment needed' }),
    new ListItem({ id: 'replace', name: 'Replace existing equipment' }),
    new ListItem({ id: 'keep', name: 'Keep existing equipment' }),
    new ListItem({ id: 'return', name: 'Return existing equipment' }),
  ];

  notes: string = 'asdasdsa';

  constructor(public storage: StorageService) {
    this.equipmentOwnershipOptions.push(
      new ListItem({ id: 'buy', name: 'Buy' }),
    );
    this.equipmentOwnershipOptions.push(
      new ListItem({ id: 'rent', name: 'Rent' }),
    );
  }

  toggleVirtualTerminalOptions(required: any) {
    let nodes = document.getElementById('virtualTerminalOptions')?.childNodes;
    if (nodes) {
      if (required) {
        for (let i = 1; i < nodes?.length; i++) {
          (nodes[i] as unknown as BaseCustomControl).disabled = true;
        }
      } else {
        for (let i = 1; i < nodes?.length; i++) {
          (nodes[i] as unknown as BaseCustomControl).disabled = true;
        }
      }
    }
  }
}
